import React,{useEffect} from 'react'
export default function Intro() {
    // const buttons = document.querySelectorAll('[data-carousel-button]')
    // buttons.forEach(button => {
    //     button.addEventListener('click', () => {
    //         console.log('button clicked')
    //         const offset = button.dataset.carouselButton === "next" ? 1 : -1
    //         const slides = button.closest("[data-carousel]").querySelector('[data-slides]')
    //         console.log(slides.children.length)

    //         const activeSlide = slides.querySelector('[data-active]')
    //         let newIndex = [...slides.children].indexOf(activeSlide) + offset
    //         if (newIndex < 0) { newIndex = slides.children.length - 1 }
    //         if (newIndex >= slides.children.length) { newIndex = 0 }
    //         slides.children[newIndex].dataset.active = true
    //         delete activeSlide.dataset.active

    //     })
    // })
    useEffect(() => {
        document.title = "Mamma's Cafe"
    })
    const prev_pic = ()=>{
        const offset=-1
        const button=document.getElementById('prev_btn')
        const slides = button.closest("[data-carousel]").querySelector('[data-slides]')
        const activeSlide = slides.querySelector('[data-active]')
        let newIndex = [...slides.children].indexOf(activeSlide) + offset
        if (newIndex < 0) { newIndex = slides.children.length - 1 }
        slides.children[newIndex].dataset.active = true
        delete activeSlide.dataset.active
    }
    const next_pic=()=>{
        const offset=1
        const button=document.getElementById('next_btn')
        const slides = button.closest("[data-carousel]").querySelector('[data-slides]')
        const activeSlide = slides.querySelector('[data-active]')
        let newIndex = [...slides.children].indexOf(activeSlide) + offset
        if (newIndex >= slides.children.length) { newIndex = 0 }
        slides.children[newIndex].dataset.active = true
        delete activeSlide.dataset.active
    }
    setInterval(() => {
        next_pic()
    }, 5000);
    return (
        <>
            <section className='section-intro intro'>
                <h1 className='pic-text'>
                    Mamma's Café
                </h1>
            <div className="booking intro">
                <button className='book_btn'>Book Now</button>
            </div>
            </section>
            <div className="content">
                <h2>City's best Cafe</h2>
                <span className="text">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque enim id unde delectus ut. Cumque repellat et repudiandae iure nam labore hic facere necessitatibus consequuntur dolorem quibusdam rerum, voluptates aliquid sapiente amet! Tempora fugiat, illum asperiores ut laboriosam, voluptate totam animi dignissimos dolorum vitae saepe sint ea nihil ipsa eveniet quod! Temporibus, placeat! Totam minima perspiciatis laudantium assumenda facere aperiam ex inventore illo, odit earum quos. Facere doloribus modi cum fugit eius nemo error voluptas voluptatum amet. Culpa eius dolorem itaque voluptates ad magni provident, atque illum repellendus adipisci sed quis. Corporis eum quas ad, asperiores est voluptas? Ut, minus?
                </span>
            </div>
            <section className='cafe-pics'>

                <div className="carousel" data-carousel>
                    <button className='carousel-button prev' data-carousel-button="prev" id="prev_btn" onClick={prev_pic}>&#10229;</button>
                    <button className='carousel-button next' data-carousel-button="next" id="next_btn" onClick={next_pic}>&#10230;</button>
                    <ul className='images' data-slides>
                        <li className='slide' data-active>
                            <img src="./images/slide2.jpg" alt="" />
                        </li>
                        <li className='slide'>
                            <img src="./images/slide1.jpg" alt="" />
                        </li>
                        <li className='slide'>
                            <img src="./images/slide3.jpg" alt="" />
                        </li>
                        <li className='slide'>
                            <img src="./images/slide4.jpg" alt="" />
                        </li>
                    </ul>

                </div>
            </section>
        </>
    )
}